module.exports = __webpack_public_path__ + "img/Болезни лучезапястного сустава и кисти.653644cb.jpg";